// src/pages/VerifyPage.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function VerifyPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const verifyAccount = async () => {
      const params = new URLSearchParams(window.location.search);
      const token = params.get('token');

      if (!token) {
        alert('Lien invalide');
        navigate('/');
        return;
      }

      try {
        // Appel à ton backend
        const res = await axios.get(`http://localhost:5000/api/clients/verify?token=${token}`);

        if (res.data && res.data.client) {
          localStorage.setItem('clientConnecte', JSON.stringify(res.data.client));

          window.dispatchEvent(new Event('clientUpdated'));

          alert('✅ Votre compte est maintenant activé !');
          navigate('/'); 
        } else {
          alert('Erreur lors de la vérification du compte.');
          navigate('/');
        }
      } catch (err) {
        console.error(err);
        alert('Lien invalide ou expiré.');
        navigate('/');
      }
    };

    verifyAccount();
  }, [navigate]);

  return (
    <div style={{ textAlign: 'center', marginTop: '100px' }}>
      <h2>Vérification du compte en cours...</h2>
      <p>Veuillez patienter quelques secondes ⏳</p>
    </div>
  );
}

export default VerifyPage;
